import Tippy from '@tippyjs/react'
import { TippyWrapper, Tooltip } from './styles'
import Text from 'components/shared/Text'
import Icon from 'components/shared/Icon'
import { useResolutions } from 'store/resolutions'
import { Color } from 'styles/types'
import { IconSize, IconVariant } from 'components/shared/Icon/types'
import { ReactElement, ReactNode } from 'react'
import Box from 'components/shared/Box'

interface InfoTooltipProps {
    message?: string | ReactNode
    color?: Color
    size?: IconSize | [IconSize, IconSize]
    isInteractive?: boolean
    isLarge?: boolean
    offsetSizes?: number
    mobilePlacement?: 'top' | 'bottom' | 'top-end'
    icon?: IconVariant
    additionalElement?: ReactElement
}

const InfoTooltip = ({
    message,
    color = 'primary_500',
    size,
    isInteractive = false,
    isLarge,
    offsetSizes,
    mobilePlacement = 'top-end',
    icon,
    additionalElement,
}: InfoTooltipProps) => {
    const { isMobile } = useResolutions()
    const mobileOffset: [number, number] = [-document.body.clientWidth, 0]
    const desktopStandardOffset: [number, number] = [24, -12]
    const desktopLargeOffset: [number, number] = [0, 5]
    const desktopOffset = isLarge ? desktopLargeOffset : desktopStandardOffset
    const desktopPlacement = isLarge ? 'top' : 'bottom-start'

    return (
        <TippyWrapper isLarge={isLarge} isChoosenIcon={!!icon}>
            <Tippy
                content={
                    <Tooltip isLarge={isLarge} offsetSizes={offsetSizes}>
                        <Text variant="bodySmall" color="grayscale_0">
                            {message}
                        </Text>
                    </Tooltip>
                }
                appendTo={isMobile ? () => document.body : 'parent'}
                offset={isMobile ? mobileOffset : desktopOffset}
                placement={isMobile ? mobilePlacement : desktopPlacement}
                interactive={isInteractive}
            >
                {additionalElement ? (
                    <Box direction="row" align="center">
                        <Icon
                            variant={icon ?? 'tooltip'}
                            color={color}
                            size={size}
                        />
                        {additionalElement}
                    </Box>
                ) : (
                    <div>
                        <Icon
                            variant={icon ?? 'tooltip'}
                            color={color}
                            size={size}
                        />
                    </div>
                )}
            </Tippy>
        </TippyWrapper>
    )
}

export default InfoTooltip
